import { UseFormSetValue } from 'react-hook-form'
import { MovePayload } from 'pages/NestedCustomers/types'
import { WalletTransferType } from 'types/unifiedPayouts/unifiedPayouts'

interface UseFormHandlers {
  setValue: UseFormSetValue<MovePayload>
}
export const useFormHandlers = ({ setValue }: UseFormHandlers) => {
  const onCustomerSelection = (customerReference: string, destinationCustomerName: string) => {
    setValue('destinationCustomerName', destinationCustomerName)
    setValue('customerReference', customerReference)
  }

  const onDestinationWalletChange = (walletId: string, destinationWalletName: string) => {
    setValue('destinationWalletName', destinationWalletName)
    setValue('destinationWallet', walletId)
  }

  const onWalletTransferTypeSelection = (walletTransferType: WalletTransferType) => {
    setValue('customerReference', '')
    setValue('destinationCustomerName', '')
    setValue('destinationWallet', '')
    setValue('destinationWalletName', '')
    setValue('walletTransferType', walletTransferType)
  }

  return {
    onCustomerSelection,
    onDestinationWalletChange,
    onWalletTransferTypeSelection,
  }
}
